// ============================================================================
// BOQ — space-type area-rate metadata
// ============================================================================
// The conceptual (Class-5) area-rate corpus (boq.area_rates) is keyed by
// (building typology x space type). Space types are a fixed methodological set
// (not user data), defined here. Rates are grouped per (typology, space_type)
// and summarised with the same escalation maths as the subtrade corpus.
// ============================================================================

export const SPACE_TYPE_LABELS = {
  whole_building: 'Whole building (all-in)',
  indoor: 'Indoor',
  indoor_people: 'Indoor (people-intensive)',
  covered_outdoor: 'Covered outdoor',
  non_covered_outdoor: 'Non-covered outdoor',
  mep: 'MEP / HVAC',
  site: 'Site / external',
};

export const SPACE_TYPES = Object.keys(SPACE_TYPE_LABELS);

export function spaceTypeLabel(t) {
  return SPACE_TYPE_LABELS[t] || t || '—';
}

// Group area-rates by (typologyId, spaceType). Rates with no typology fall into
// a '(none)' bucket so they are still visible. Returns a Map keyed
// "<typologyId|none>::<spaceType>" -> rate[].
export function groupByTypologySpace(rates) {
  const map = new Map();
  (rates || []).forEach((r) => {
    const key = `${r.typologyId || 'none'}::${r.spaceType}`;
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(r);
  });
  return map;
}
